export enum ProductStatus {
    Unactioned = 'Unactioned',
    Actioned = 'Actioned',
    Superseded = 'Superseded'
}